import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fillRule="evenodd"
    clipRule="evenodd"
    fill="currentColor"
    {...props}
  >
    <path d="M9.61181 0C14.9117 0 19.2226 4.21587 19.2226 9.39884C19.2226 11.8441 18.2631 14.0744 16.6928 15.7482L19.7826 18.7636C20.0718 19.0464 20.0728 19.5039 19.7836 19.7867C19.6395 19.9295 19.449 20 19.2595 20C19.071 20 18.8815 19.9295 18.7365 19.7886L15.6093 16.739C13.9643 18.0273 11.8785 18.7986 9.61181 18.7986C4.31194 18.7986 0 14.5818 0 9.39884C0 4.21587 4.31194 0 9.61181 0ZM9.61181 1.44776C5.12814 1.44776 1.48041 5.01407 1.48041 9.39884C1.48041 13.7836 5.12814 17.3509 9.61181 17.3509C14.0945 17.3509 17.7422 13.7836 17.7422 9.39884C17.7422 5.01407 14.0945 1.44776 9.61181 1.44776Z" />
  </svg>
);
